/**
 * F23 — Prayer journal (private notes). Stored locally only; never log body to analytics.
 */
const STORAGE_KEY = 'prayer_journal_v1';

function loadEntries() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveEntries(entries) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    /* quota */
  }
}

export function listJournalEntries() {
  return loadEntries().sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
}

export function addJournalEntry(body) {
  const text = String(body || '').trim();
  if (!text) return null;
  const entry = {
    id: `pj_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    body: text,
    createdAt: new Date().toISOString(),
  };
  const next = [entry, ...loadEntries()];
  saveEntries(next);
  return entry;
}

export function deleteJournalEntry(id) {
  const next = loadEntries().filter((e) => e.id !== id);
  saveEntries(next);
}

/** Remove private journal entries from this device (called on logout / session expiry). */
export function clearPrayerJournal() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
